import { LRL_TOKENS } from '@lrl/ui-tokens';

export interface LogoMarkProps {
  size?: number;
  className?: string;
}

export function LogoMark({ size = 32, className }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      className={className}
      aria-label="Lisbon Racket League logo"
      role="img"
    >
      <circle cx="20" cy="20" r="19" fill={LRL_TOKENS.primary} />
      <circle cx="20" cy="20" r="13" fill="none" stroke={LRL_TOKENS.accent} strokeWidth="1.6" />
      <path d="M7 20 Q20 28 33 20" stroke={LRL_TOKENS.accent} strokeWidth="1.6" fill="none" />
      <path d="M7 20 Q20 12 33 20" stroke={LRL_TOKENS.accent} strokeWidth="1.6" fill="none" />
    </svg>
  );
}
